import PropTypes from 'prop-types';

export const formPropType = {
  validateFields: PropTypes.func.isRequired,
  getFieldsValue: PropTypes.func.isRequired,
  getFieldDecorator: PropTypes.func.isRequired,
  getFieldError: PropTypes.func.isRequired,
  isFieldTouched: PropTypes.func.isRequired,
};
